"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var widgets_1 = require("@tableau/widgets");
var DataQualityWarningViewHeader_1 = require("../DataQualityWarnings/DataQualityWarningViewHeader");
var ViewerPaneStyles_1 = require("./ViewerPaneStyles");
exports.headerDetailsHeaderTestId = 'data-details-about-section-header';
/** A widget to display author and timestamp information in the lineage panel */
function HeaderDetails(props) {
    return (React.createElement(ViewerPaneStyles_1.HeaderWrapper, null,
        props.sparklineElement,
        React.createElement(data_catalog_shared_1.MetadataTable.Table, { valueCellFlexGrow: 3 },
            WorkbookRow(props),
            ProjectRow(props),
            AuthorRow(props),
            props.modifiedDate ? DateRow(props.modifiedDate) : null,
            DataQualityWarningRow(props.datasources))));
}
exports.HeaderDetails = HeaderDetails;
function WorkbookRow(props) {
    return (React.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) {
        return React.createElement(data_catalog_shared_1.MetadataTable.Row, null,
            React.createElement(data_catalog_shared_1.MetadataTable.LabelCell, { "data-tb-test-id": 'data-details-workbook-header-label' }, Localize_1.Messages.WorkbookHeaderLabel()),
            React.createElement(data_catalog_shared_1.MetadataTable.ValueCell, { "data-tb-test-id": 'data-details-workbook-header-value' }, props.workbookName != null ?
                React.createElement(widgets_1.TextLinkWidget, { href: urls.workbookDetailsUrl(props.workbookVizportalUrlId), target: '_blank', testId: 'data-details-workbook-header-link' }, props.workbookName)
                : data_catalog_shared_1.ViewerPaneObfuscatedPlaceholder()));
    }));
}
function ProjectRow(props) {
    return (React.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) {
        return React.createElement(data_catalog_shared_1.MetadataTable.Row, null,
            React.createElement(data_catalog_shared_1.MetadataTable.LabelCell, { "data-tb-test-id": 'data-details-project-header-label' }, Localize_1.Messages.DataDetailsProjectLabel()),
            React.createElement(data_catalog_shared_1.MetadataTable.ValueCell, { "data-tb-test-id": 'data-details-project-header-value' },
                React.createElement(widgets_1.TextLinkWidget, { href: props.projectVizportalUrlId ? urls.projectUrl(props.projectVizportalUrlId) : undefined, target: '_blank', testId: 'data-details-project-header-link' }, props.projectName)));
    }));
}
function AuthorRow(props) {
    return (React.createElement(data_catalog_shared_1.MetadataTable.Row, null,
        React.createElement(data_catalog_shared_1.MetadataTable.LabelCell, { "data-tb-test-id": 'data-details-author-header-label' }, Localize_1.Messages.AuthorHeaderLabel()),
        React.createElement(data_catalog_shared_1.MetadataTable.ValueCell, { "data-tb-test-id": 'data-details-author-header-value' },
            React.createElement(data_catalog_shared_1.UserLinkDisplayComponent, { user: props.owner, linkComponent: function (_a) {
                    var name = _a.name, url = _a.url;
                    return (React.createElement(widgets_1.TextLinkWidget, { href: url, target: '_blank', testId: 'data-details-author-header-link' }, name));
                } }))));
}
function DateRow(date) {
    // This function assumes that `date` is in ISO 8601 format.
    return (React.createElement(data_catalog_shared_1.MetadataTable.Row, null,
        React.createElement(data_catalog_shared_1.MetadataTable.LabelCell, { "data-tb-test-id": 'data-details-date-header-label' }, Localize_1.Messages.DateHeaderLabel()),
        React.createElement(data_catalog_shared_1.MetadataTable.ValueCell, { "data-tb-test-id": 'data-details-date-header-value' }, Localize_1.Formatters.formatMediumDateTimeWithoutSeconds(new Date(date)))));
}
function DataQualityWarningRow(datasources) {
    var datasourceIds = datasources.map(function (datasource) { return datasource.id; });
    return React.createElement(DataQualityWarningViewHeader_1.DataQualityWarningViewHeader, { datasourceIds: datasourceIds });
}
//# sourceMappingURL=HeaderDetails.js.map